import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=7721ce0d&scoped=true"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7721ce0d",
  null
  
)

export default component.exports